import { render, staticRenderFns } from "./SalesVolume.vue?vue&type=template&id=3ffe813c"
import script from "./SalesVolume.vue?vue&type=script&lang=js"
export * from "./SalesVolume.vue?vue&type=script&lang=js"
import style0 from "./SalesVolume.vue?vue&type=style&index=0&id=3ffe813c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports